export default __webpack_public_path__ + "static/media/project-wizard-communication_dark.fe4215eb.png";